import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import {getStockList} from "../API";
import {
    Button,
    ButtonGroup,
    Chip,
    Table,
    Pagination,
    TableBody, TableCell,
    TableColumn,
    TableHeader,
    TableRow,
    Tooltip,
    User, Autocomplete, AutocompleteItem
} from "@nextui-org/react";
import {FaEdit, FaPlusCircle, FaRegPauseCircle, FaRegPlayCircle} from "react-icons/fa";
import {StockStatus} from './Globals'

const statusColorMap = StockStatus;

export default function StockList(){
    const [stockList, setStockList] = React.useState([]);
    const navigate = useNavigate();
    const [page, setPage] = React.useState(1);
    const rowsPerPage = 20;

    const columns = [
        {name: "STOCK", uid: "idstock", center: true},
        {name: "PRODUCTO", uid: "product", center: false},
        {name: "CODIGO", uid: "code", center: false},
        {name: "ESTADO", uid: "status", center: true},
        {name: "CELDA", uid: "idposition_code", center: false},
        {name: "MAQUINA", uid: "idmachine", center: false},
        {name: "REPOSITOR", uid: "user_assigned", center: true},
        {name: "DEPOSITO", uid: "deposit_name", center: true},
        {name: "CREADO EL", uid: "date", center: true},
    ];



    const pages = Math.ceil(stockList.length / rowsPerPage);

    const items = React.useMemo(() => {
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;

        return stockList.slice(start, end);
    }, [page, stockList]);

    useEffect(() => {
        Starting();
    }, []);

    async function Starting() {
        const p = await getStockList();
        setStockList(p);
    }

    const renderCell = React.useCallback((product, columnKey) => {
        const cellValue = product[columnKey];
        switch (columnKey) {

            case "date":
                const date = new Date(cellValue);
                return <>{date.toLocaleDateString()}</>;

            case "status":
                return (
                    <Chip color={statusColorMap[cellValue][0]}>{statusColorMap[cellValue][1]}</Chip>
                )

            case "actions":
                return (
                    <div className="relative flex items-center gap-2">

                        <Button  color="transparent" isIconOnly>
                            <Tooltip content="Editar producto">
                                  <span className="text-lg text-default-400 cursor-pointer active:opacity-50">
                                    <FaEdit/>
                                  </span>
                            </Tooltip>
                        </Button>
                        <Button  color="transparent" isIconOnly>
                            {
                                product.active ? (

                                    <Tooltip color="danger" content="Desactivar producto">
                                      <span className="text-lg text-danger cursor-pointer active:opacity-50">
                                        <FaRegPauseCircle/>
                                      </span>
                                    </Tooltip>
                                ) : (
                                    <Tooltip color="success" content="Activar producto">
                                      <span className="text-lg text-success cursor-pointer active:opacity-50">
                                        <FaRegPlayCircle/>
                                      </span>
                                    </Tooltip>
                                )
                            }
                        </Button>


                    </div>
                );
            default:
                return cellValue;
        }
    }, []);

    return (
        <div className="container flex flex-col">
            <h1 className="text-center pb-5 text-2xl">Lista de stock</h1>

            <Table aria-label="Stock"
                   bottomContent={
                       <div className="flex w-full justify-center">
                           <Pagination
                               isCompact
                               showControls
                               showShadow
                               color="secondary"
                               page={page}
                               total={pages}
                               onChange={(page) => setPage(page)}
                           />
                       </div>
                   }
            >
                <TableHeader columns={columns}>
                    {(column) => (
                        <TableColumn key={column.uid} className={column.center ? "text-center" : "text-left"}>
                            {column.name}
                        </TableColumn>
                    )}
                </TableHeader>
                <TableBody items={items}>
                    {(item) => (
                        <TableRow key={item.idstock} className="text-center">
                            {(columnKey) => <TableCell>{renderCell(item, columnKey)}</TableCell>}
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </div>

    );
}